<template>
  <div class="a-r-box">

    <div class="a-r-list">
      <div class="a-r-top-t flex-b-c" style="padding: 0px 8px;">
        <div class="flex-c">
          <span>{{ $t('aci1') }}</span>
          <div style="width: 260px;margin-left: 16px;"><scrolling-text :text="$t('nswce11')"
              :speed="10"></scrolling-text></div>
        </div>
        <!-- <span>({{ $t('nswce11') }})</span> -->
      </div>
      <div class="a-r-list-item" :key="now">
        <el-collapse v-model="activeName" accordion @change="collapseChange">
          <el-collapse-item :name="index + ''" v-for="(arItem, index) in arList" :key="arItem.ar_id">
            <template #title>
              <div class="flex-b-c" style="width: 100%;">
                <div>
                  <i class="custom-arrow el-icon-arrow-right" :class="{ 'is-active': activeName === '1' }"
                    style="margin-right: 8px;"></i>
                  <span>{{ arItem.ar_name }}</span>
                </div>
                <div @click="(event) => { event.stopPropagation() }">
                  <el-tooltip class="item" effect="dark" :content="$t('acl1')" placement="top"
                    :disabled="!(arList[activeName].list.length < 2)">
                    <el-button size="mini" @click="publish(arItem)" :disabled="arList[index].list.length < 2"
                      type="success">{{ $t('acit2') }}</el-button>
                  </el-tooltip>
                  <el-button size="mini" @click="addArItem(arItem.ar_id, arItem.ar_name)" type="primary">{{ $t('acit3')
                  }}</el-button>
                  <el-button size="mini" @click="delArTimerplay(arItem.ar_id, 0)" type="danger"
                    style="margin-right: 8px;">{{ $t('acit4') }}</el-button>
                </div>
              </div>
            </template>
            <ul style="margin-left: 16px;">
              <li class="flex-b-c a-r-p-item"
                :class="{ activate: index === arItemIndex, 'is-dragging': moveNode && moveNode.target.id == item.id }"
                v-for="(item, index) in arItem.list" :key="item.id" :data-index="index" :id="item.id"
                data-drag="drag" draggable="true" @dragover="dragover" @drop="drop" @dragenter="dragenter($event, arItem)"
                @dragstart="dragstart" @dragend="dragend($event, arItem)" @click="activateProgram(item.id, index)">
                <div class="a-r-p-item-img flex-a-c noclick">
                  <img style="width: 86px; height: 48px;object-fit: contain;" v-if="item.damaged === 0"
                    :src="item.pimg_path" alt />
                  <img style="width: 86px; height: 48px;object-fit: contain;" v-else src="@imgpub/damaged.png" alt />
                </div>
                <div class="a-r-p-item-info noclick">
                  <div style="width: 180px;" class="ellipsis-1">{{ $t('acit5') }}: {{ item.play_name }}</div>
                  <span>{{ $t('acit6') }}: {{ item.playCount }}</span>
                </div>
                <div class="a-r-p-item-btn">
                  <el-button size="mini" @click="delArTimerplay(0, item.id)" type="danger">{{ $t('acit4') }}</el-button>
                </div>
              </li>
            </ul>
          </el-collapse-item>
        </el-collapse>
        <add-ar-btn :name="$t('aci1')" @add="addAr"></add-ar-btn>
      </div>
    </div>
    <div class="a-r-info">
      <template v-if="arList.length">
        <div class="a-r-top-t">{{ arList[activeName].list[arItemIndex].play_name }}</div>
        <val-set-box>
          <div class="aaic-item">
            <el-radio v-model="isPlayCount" :label="1" @change="(val) => { changeValue('isPlayCount', val) }">{{
              $t('acit6') }}</el-radio>
            <span style="font-size: 14px;color: #606266;padding-right: 10px;">{{ $t('acit7') }}</span>
            <el-input-number :disabled="isPlayCount == 0" style="width: 160px;" size="mini" v-model="playCount" :min="1"
              @change="(val) => { changeValue('playCount', val) }"></el-input-number>
          </div>
          <div class="aaic-item">
            <el-radio v-model="isPlayCount" :label="0" @change="(val) => { changeValue('isPlayCount', val) }">{{
              $t('acit8') }}</el-radio>
            <span style="font-size: 14px;color: #606266;padding-right: 10px;">{{ $t('acit9') }}</span>
            <el-time-picker :disabled="isPlayCount == 1" style="width: 160px;" size="mini" v-model="playTime"
              @change="(val) => { changeValue('playTime', val) }">
            </el-time-picker>
          </div>
        </val-set-box>
      </template>
    </div>
    <div class="a-r-pinfo">
      <template v-if="arList.length">
        <div class="a-r-top-t">{{ arList[activeName].list[arItemIndex].play_name }}</div>
        <program-info :program="arList[activeName].list[arItemIndex]"
          :key="arList[activeName].list[arItemIndex].play_id"></program-info>
      </template>
    </div>
    <add-dialog :dialogVisible="addArNameDialog" @closeDialog="closeAddArName" :title="$t('aci1')">
      <el-input v-model="arName">
        <template slot="prepend">{{ $t('aci1') }}</template>
      </el-input>
    </add-dialog>
    <program-list :dialogVisible="programListListDV" @selectProgramList="selectProgramList"
      @closeDialog="() => { programListListDV = false; }"></program-list>
    <terminal-list :terminalListDV="terminalListDV" @publishTerminal="publishTerminal" :append="false"
      :diffIsAppend="1"></terminal-list>
  </div>
</template>

<script>
// import superClone from '@/assets/scripts/superClone.js';
import { timeFormatting, reTimeFormatting, totalMilliseconds } from "@/assets/scripts/dateFormatting";
import ProgramList from '../../schedule/windows/children/ProgramList'
import AddDialog from '@/components/basics/AddDialog'
import ProgramInfo from './ProgramInfo'
import TerminalList from '../../schedule/windows/children/TerminalList';
import groupIdInfo from "@/assets/scripts/groupIdInfo.js";
import AddArBtn from './items/AddArBtn';
import ValSetBox from './items/ValSetBox';
import ScrollingText from './items/ScrollingText';
export default {
  name: "Loops",
  data() {
    return {
      loading: false,
      activeName: '0',
      lastActiveName: '0',
      arItemIndex: 0,
      arList: [],
      playCount: 1,
      playTime: '',
      isPlayCount: 0,
      isPlayTime: 0,
      timeoutId: 0,
      addArNameDialog: false,
      arName: this.$t('aci1'),
      programListListDV: false,
      arItemName: '',
      arItemId: '',
      isAddArItem: false,
      terminalListDV: false,
      arItem: {},
      moveNode: null,
      sortChanged: false,
      now: Date.now()
    }
  },
  created() {
    // this.loading = true;
    this.getListAr();
  },
  methods: {
    publish(arItem) {
      this.arItem = arItem;
      this.terminalListDV = true;
    },
    getPublishArData() {
      const { list } = this.arItem;

      let play_ids = [];
      let usePlayTimeList = [];
      let playTimeList = [];
      let playCountList = [];

      list.forEach(p => {
        const { play_id, isPlayCount, isPlayTime, playCount, playTime } = p;
        play_ids.push(play_id);
        usePlayTimeList.push(isPlayTime ? 1 : 0);
        playTimeList.push(isPlayTime ? totalMilliseconds(playTime) : -1);
        playCountList.push(isPlayCount ? playCount : -1);
      });

      return { play_ids, usePlayTimeList, playTimeList, playCountList }
    },
    publishTerminal(terminalList, adapter_screen, isAppend) {

      if (terminalList.length === 0) {
        this.terminalListDV = false;
        return;
      }
      const group_id = this.$cookies.get("group_id");

      const gInfo = groupIdInfo(group_id);
      let isCheck = false;
      if (gInfo) {
        const { check_state } = gInfo;
        isCheck = (check_state & 1);
      }
      const { play_ids, usePlayTimeList, playTimeList, playCountList } = this.getPublishArData();

      let devIds = terminalList.map(d => d.id);

      this.$http.post("/admin/publish/addNew", {
        group_id: group_id,
        play_ids: play_ids.join(','),
        list_group: encodeURIComponent(JSON.stringify([{ main_device: "", ids: devIds }])),
        play_mode: 1,
        publish_strategy: 0,
        publish_type: 1,
        isAppend: isAppend,
        adapter_screen: adapter_screen ? 1 : 0,
        is_drafts: 0,
        usePlayTimeList: usePlayTimeList.join(','),
        playTimeList: playTimeList.join(','),
        playCountList: playCountList.join(','),
        publish_name: `${this.$t('aci1')}-${new Date().getTime()}`
      }, () => {
        this.$http.post("/admin/Command/getDownloadList", {}, (res) => {
          this.$store.commit("ISSUE_LIST", res);
          !isCheck && this.$bus.$emit('publish-event', "open-download");
        });
        this.terminalListDV = false;
      }).catch(() => {
        this.terminalListDV = false;
      });

      if (isCheck) {
        this.$msg({ message: this.$t('cspm11'), type: 'warning', });
      } else {
        this.$msg({ message: this.$t('cspm10'), type: 'success', });
      }
    },
    addArItem(arId, arName) {
      this.arItemName = arName;
      this.arItemId = arId;
      this.isAddArItem = true;
      this.programListListDV = true;
    },
    addAr() {
      this.addArNameDialog = true;
      this.isAddArItem = false;
    },
    closeAddArName(Confirm) {
      if (Confirm) {
        this.programListListDV = true;
      }
      this.addArNameDialog = false;
    },
    async selectProgramList(list = []) {
      this.programListListDV = false;
      if (!list.length) {
        return;
      }

      let arId = this.$uuid.v4();
      let arName = this.arName;
      if (this.isAddArItem) {
        arId = this.arItemId;
        arName = this.arItemName;
      }

      this.addArLoops(list, arId, arName);
    },
    async addArLoops(list, arId, arName) {
      for (let index = 0; index < list.length; index++) {
        const program = list[index];
        const { id, name } = program;
        const arData = {
          ar_id: arId,
          ar_name: arName,
          group_id: this.$cookies.get("group_id"),
          play_id: id,
          play_name: name,
          isPlayCount: 1,
          isPlayTime: 0,
          playCount: 1,
          playTime: '00:01:00',
        };
        await this.$http.post("/admin/AdvancedRelease/addArLoops", arData, data => {
          console.log(data);
          this.getListAr();
        });
      }
    },
    init(data) {
      const { playCount, isPlayCount, isPlayTime, playTime } = data;
      this.isPlayCount = isPlayCount;
      this.isPlayTime = isPlayTime;
      this.playCount = playCount;
      this.playTime = reTimeFormatting(playTime);
    },
    getListAr() {
      // this.loading = true;
      this.$http.post(`/admin/AdvancedRelease/listArLoops`, {}, data => {
        const list = data.list || [];

        if (list.length && ((list.length <= parseInt(this.activeName)) || (this.arList.length < list.length))) {
          const index = list.length - 1;
          this.activeName = index + '';
          this.arItemIndex = 0;
        }
        this.arList = list;
        this.arList.length && this.init(this.arList[this.activeName].list[this.arItemIndex]);
        this.loading = false;
      }).catch(() => {
        this.arList = [];
        this.loading = false;
      });
    },
    collapseChange(val) {
      if (val) {
        this.activeName = val;
        this.lastActiveName = val;
        this.arItemIndex = 0;
      } else {
        this.activeName = this.lastActiveName;
        this.now = Date.now();
      }
    },
    activateProgram(id, index) {
      this.arItemIndex = index;
    },
    // 列表项拖拽排序（参照 WindowList 实现）
    dragstart(event) {
      this.moveNode = event;
      this.sortChanged = false;
      // 同步加类，保证浏览器抓取的拖拽影像（跟随鼠标的元素）即刻变色
      event.target.classList.add('is-dragging');
    },
    dragenter(event, arItem) {
      if (this.moveNode) {
        this.moveArItem(event, arItem);
      }
    },
    dragover(event) {
      event.preventDefault();
    },
    drop() {
      // 内部排序在 dragenter 中已完成换位，无需处理
    },
    dragend(event, arItem) {
      const changed = this.sortChanged;
      event.target.classList.remove('is-dragging');
      this.moveNode = null;
      this.sortChanged = false;
      if (changed) {
        this.saveSortArLoops(arItem);
      }
    },
    moveArItem(event, arItem) {
      if (!event.target.getAttribute("data-drag")) { return; }
      if (this.moveNode.target.id == event.target.id) { return; }

      const list = arItem.list;
      const index = parseInt(event.target.getAttribute("data-index"));
      const activeId = list[this.arItemIndex] ? list[this.arItemIndex].id : null;

      let direction = "";//true - up ,false - down
      event.offsetY > 50 && (direction = 'up');
      event.offsetY < 10 && (direction = 'down');

      if (direction === 'up' && index + 1 < list.length) {
        this.arItemSwap(list, index, index + 1, activeId);
        this.sortChanged = true;
      }
      if (direction === 'down' && index - 1 >= 0) {
        this.arItemSwap(list, index, index - 1, activeId);
        this.sortChanged = true;
      }
    },
    arItemSwap(list, index_1, index_2, activeId) {
      let temp = list[index_1];
      this.$set(list, index_1, list[index_2]);
      this.$set(list, index_2, temp);
      // 选中项跟随移动，避免 arItemIndex 指错
      let activeIndex = list.findIndex((p) => p.id == activeId);
      if (activeIndex !== -1) {
        this.arItemIndex = activeIndex;
      }
    },
    saveSortArLoops(arItem) {
      const ids = arItem.list.map(item => item.id).join(',');
      this.$http.post("/admin/AdvancedRelease/sortArLoops", {
        ar_id: arItem.ar_id,
        ids: ids
      }, () => { });
    },
    delArTimerplay(arId = 0, ids = 0) {
      this.$http.post("/admin/AdvancedRelease/delArLoops", { ar_id: arId, ids: ids }, data => {
        console.log(data);
        this.arItemIndex = 0;
        this.getListAr();
      });
    },
    changeValue(key, value) {
      console.log(key, value);
      let data = {};
      switch (key) {
        case 'playTime':
          data = { playTime: timeFormatting(value) };
          break;
        case 'playCount':
          data = { [key]: value };
          break;
        case 'isPlayCount':
          data = { isPlayCount: value ? 1 : 0, isPlayTime: value ? 0 : 1 };
          break;
        default:
          break;
      }

      this.arList[this.activeName].list[this.arItemIndex] = { ...this.arList[this.activeName].list[this.arItemIndex], ...data };

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = 0;
      }

      const { id } = this.arList[this.activeName].list[this.arItemIndex];

      this.timeoutId = setTimeout(() => {
        this.$http.post("/admin/AdvancedRelease/editArLoops", {
          id, ...data
        }, data => {
          console.log(data);
        });
      }, 500);
    }
  },
  watch: {
    activeName: {
      handler(nd) {
        this.init(this.arList[nd].list[this.arItemIndex]);
      }
    },
    arItemIndex: {
      handler(nd) {
        this.init(this.arList[this.activeName].list[nd]);
      }
    },
  },
  components: {
    ProgramInfo,
    ProgramList,
    AddDialog,
    TerminalList,
    AddArBtn,
    ValSetBox,
    ScrollingText
  }
}
</script>


<style lang="scss" scoped>
@import './arStyle.scss';

.a-r-box {
  display: flex;
  height: 100%;
}

.a-r-top-t {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-bottom: 1px solid #409EFF;
  overflow: hidden;
}

.a-r-list {
  width: 360px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
  margin-right: 12px;

  /* 隐藏默认箭头 */
  /deep/ .el-collapse-item__arrow {
    display: none !important;
  }

  /* 自定义箭头样式 */
  .custom-arrow {
    margin-right: 8px;
    transition: transform 0.3s;
  }

  .el-collapse-item__header.is-active .custom-arrow {
    transform: rotate(90deg);
  }

  .a-r-p-item {
    user-select: none;
    height: 60px;
    cursor: move;

    &.is-dragging {
      background-color: var(--theme-color-customized-1);
    }
  }

  .a-r-p-item-img {
    width: 88px;
    height: 50px;
    background-color: #000;
  }

  .a-r-p-item-info {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .a-r-p-item-btn {
    width: 60px;
  }

  .a-r-list-item {
    height: calc(100% - 56px);
    overflow-y: auto;
    margin: 8px 0px;
  }

  /* .add-ar-item-c-add {
    background-color: #ccc;
    width: 100%;
    height: 40px;
    min-height: 40px;
    border-radius: 8px;
    user-select: none;
  } */
}

.a-r-info {
  width: 260px;
  flex-grow: 1;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
}

.a-r-pinfo {
  width: 300px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #409EFF;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
}

.aaic-item {
  margin: 8px 0px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.noclick {
  pointer-events: none;
  /* 上层加上这句样式可以实现点击穿透 */
}
</style>